import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-specialized-operator',
    template:
        '<app-header></app-header>' +
        '<app-specialized-operator-sidebar></app-specialized-operator-sidebar>' +
        '<router-outlet></router-outlet>'
})
export class SpecializedOperatorComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/specialized-operator/specialized-operator.component.ts